module.exports = __webpack_public_path__ + "img/night_moon.68f4d642.svg";